import React, { useState } from 'react';
import { HelpCircle, X } from 'lucide-react';
type TourButtonProps = {
  onStartTour: () => void;
};
export function TourButton({
  onStartTour
}: TourButtonProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  return <div className="fixed bottom-6 right-6 z-40" data-id="element-2623">
      {/* Tooltip */}
      {showTooltip && <div className="absolute bottom-16 right-0 bg-gray-900 text-white px-4 py-2 rounded-lg shadow-lg mb-2 whitespace-nowrap" data-id="element-2624">
          <div className="text-sm font-medium" data-id="element-2625">Restart Tour</div>
          <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900" data-id="element-2626"></div>
        </div>}

      {/* Button */}
      <button onClick={onStartTour} onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} className="w-12 h-12 bg-white border-2 border-gray-200 rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 hover:border-gray-300 transition-all hover:scale-110" aria-label="Help and Tour" data-id="element-2627">
        <HelpCircle className="w-6 h-6 text-gray-600" data-id="element-2628" />
      </button>
    </div>;
}